import React, { useEffect, useRef, useState } from "react";
import { Fade, Menu } from "@mui/material";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { useTour } from "@reactour/tour";

import IconButton from "./common/IconButton";
import { getUserName, getUserRole } from "../selectors/app";
import { logoutUser as logoutUserRequest } from "../actions/app";

import quickGuideIcon from "../assets/quickguideicon.svg";
import knowledgebaseicon from "../assets/knowledgebaseicon.svg";
import logouticon from "../assets/logouticon.svg";
import userIcon from "../assets/User_fill.svg";

import "../styles/accountmenu.scss";

const AccountMenu = (props) => {
    const { userName, userRole, logoutUser } = props;

    const { setIsOpen, setCurrentStep, steps } = useTour();
    const location = useLocation();
    const navigate = useNavigate();
    const logoutModalRef = useRef(null);
    const mediaQueryMobile = window.matchMedia("(max-width:768px)");
    const companyId = localStorage.getItem("company");
    const isBpad =
        companyId &&
        (companyId === "6381099636eb54641ed5c988" ||
            companyId === "64075efbe58189914932e7b1");

    const [locationState, setLocationState] = useState(false);
    const [openLogoutModal, setOpenLogoutModal] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const openEl = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onLogout = () => {
        logoutUser({
            userType: null,
            navigate,
            redirectUrl: isBpad ? "/signin?company=BPAD" : "",
        });
    };

    useEffect(() => {
        if (window.location.pathname === "/my-account") {
            setLocationState(true);
        }
    }, []);

    useEffect(() => {
        if (logoutModalRef.current) {
            if (openLogoutModal) {
                logoutModalRef.current.style = "display: block";
                window.addEventListener("click", handleOutsideClick);
            } else {
                logoutModalRef.current.style = "display: none";
            }
        }
    }, [openLogoutModal]);

    const handleOutsideClick = (e) => {
        if (e.target === logoutModalRef.current) {
            setOpenLogoutModal(false);
        }
    };

    return (
        <>
            {mediaQueryMobile.matches ? (
                <div
                    className="settingsIconContainer"
                    onClick={(event) => handleClick(event)}
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className={
                            openEl || locationState ? "settingsIconSvg" : ""
                        }
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M11.9838 0.541611C12.0711 0.710929 12.0928 0.927766 12.1361 1.36144C12.2182 2.1823 12.2593 2.59274 12.4311 2.81793C12.649 3.10358 13.0034 3.25038 13.3595 3.20248C13.6402 3.16472 13.9594 2.90352 14.5979 2.38113C14.9352 2.10515 15.1038 1.96716 15.2853 1.90918C15.5158 1.83555 15.7652 1.84798 15.9872 1.94419C16.162 2.01994 16.3161 2.17402 16.6243 2.4822L17.5178 3.37567C17.8259 3.68385 17.98 3.83794 18.0558 4.01275C18.152 4.23478 18.1644 4.48415 18.0908 4.71464C18.0328 4.89612 17.8948 5.06478 17.6188 5.4021C17.0964 6.0406 16.8352 6.35984 16.7975 6.64056C16.7496 6.99662 16.8964 7.35102 17.182 7.56893C17.4072 7.74072 17.8176 7.78176 18.6385 7.86385C19.0722 7.90722 19.2891 7.92891 19.4584 8.01624C19.6734 8.12716 19.841 8.31228 19.9299 8.53729C20 8.71447 20 8.93239 20 9.36824V10.6319C20 11.0676 20 11.2855 19.93 11.4626C19.841 11.6877 19.6734 11.8729 19.4583 11.9838C19.289 12.0711 19.0722 12.0928 18.6386 12.1361L18.6386 12.1361C17.818 12.2182 17.4077 12.2592 17.1825 12.4309C16.8967 12.6489 16.7499 13.0034 16.7979 13.3596C16.8357 13.6402 17.0968 13.9593 17.619 14.5976C17.8949 14.9348 18.0328 15.1034 18.0908 15.2848C18.1645 15.5154 18.152 15.7648 18.0558 15.9869C17.98 16.1617 17.826 16.3157 17.5179 16.6238L16.6243 17.5174C16.3162 17.8255 16.1621 17.9796 15.9873 18.0554C15.7652 18.1516 15.5159 18.164 15.2854 18.0904C15.1039 18.0324 14.9352 17.8944 14.5979 17.6184L14.5979 17.6184C13.9594 17.096 13.6402 16.8348 13.3595 16.7971C13.0034 16.7492 12.649 16.896 12.4311 17.1816C12.2593 17.4068 12.2183 17.8173 12.1362 18.6383C12.0928 19.0722 12.0711 19.2891 11.9837 19.4585C11.8728 19.6735 11.6877 19.8409 11.4628 19.9299C11.2856 20 11.0676 20 10.6316 20H9.36824C8.93239 20 8.71447 20 8.53729 19.9299C8.31228 19.841 8.12716 19.6734 8.01624 19.4584C7.92891 19.2891 7.90722 19.0722 7.86385 18.6385C7.78176 17.8176 7.74072 17.4072 7.56892 17.182C7.35101 16.8964 6.99663 16.7496 6.64057 16.7975C6.35985 16.8352 6.04059 17.0964 5.40208 17.6189L5.40206 17.6189C5.06473 17.8949 4.89607 18.0329 4.71458 18.0908C4.4841 18.1645 4.23474 18.152 4.01272 18.0558C3.8379 17.9801 3.6838 17.826 3.37561 17.5178L2.48217 16.6243C2.17398 16.3162 2.01988 16.1621 1.94414 15.9873C1.84794 15.7652 1.8355 15.5159 1.90913 15.2854C1.96711 15.1039 2.10511 14.9352 2.3811 14.5979C2.90351 13.9594 3.16471 13.6402 3.20247 13.3594C3.25037 13.0034 3.10357 12.649 2.81792 12.4311C2.59273 12.2593 2.1823 12.2182 1.36143 12.1361C0.927764 12.0928 0.71093 12.0711 0.541612 11.9838C0.326558 11.8728 0.159016 11.6877 0.0700471 11.4627C0 11.2855 0 11.0676 0 10.6318V9.36835C0 8.9324 0 8.71442 0.0700841 8.53721C0.15905 8.31226 0.326541 8.12719 0.541523 8.01628C0.710878 7.92891 0.927769 7.90722 1.36155 7.86384H1.36155H1.36156C2.18264 7.78173 2.59319 7.74068 2.81842 7.56881C3.10395 7.35092 3.2507 6.99664 3.20287 6.64066C3.16514 6.35987 2.90385 6.04052 2.38128 5.40182C2.10516 5.06435 1.96711 4.89561 1.90914 4.71405C1.83557 4.48364 1.848 4.23438 1.94413 4.01243C2.01988 3.83754 2.17403 3.68339 2.48233 3.37509L3.37565 2.48177L3.37566 2.48177C3.68385 2.17357 3.83795 2.01947 4.01277 1.94373C4.23478 1.84753 4.48414 1.8351 4.71463 1.90872C4.89612 1.9667 5.06481 2.10472 5.4022 2.38076C6.04061 2.9031 6.35982 3.16427 6.64044 3.20207C6.99661 3.25003 7.35113 3.10319 7.56907 2.81742C7.74077 2.59227 7.78181 2.18195 7.86387 1.36131C7.90722 0.927757 7.9289 0.710983 8.01619 0.541704C8.12712 0.326575 8.31231 0.158981 8.53741 0.0700092C8.71453 0 8.93238 0 9.3681 0H10.6318C11.0676 0 11.2855 0 11.4627 0.0700478C11.6877 0.159016 11.8728 0.326558 11.9838 0.541611ZM10 14C12.2091 14 14 12.2091 14 10C14 7.79086 12.2091 6 10 6C7.79086 6 6 7.79086 6 10C6 12.2091 7.79086 14 10 14Z"
                            fill="#A9A9A9"
                        />
                    </svg>
                </div>
            ) : (
                <div className="tooltip">
                    <IconButton
                        onClick={(event) => handleClick(event)}
                        aria-label="notification"
                        id="testLogoutFlow-selector-2"
                        style={{ display: "flex" }}
                    >
                        <img src={userIcon} alt="" width={24} height={24} />
                    </IconButton>
                    <span className="tooltiptext">Profile</span>
                </div>
            )}
            <Menu
                id="fade-menu"
                MenuListProps={{
                    "aria-labelledby": "fade-button",
                    className: "menuList",
                }}
                anchorEl={anchorEl}
                open={openEl}
                onClose={handleClose}
                TransitionComponent={Fade}
                PaperProps={{
                    className: "menu-list-container",
                    style: {
                        minWidth: "350px",
                        borderRadius: "30px",
                    },
                }}
            >
                <div className="accountmenu">
                    <div className="accountmenu-title">
                        <div>
                            <h2>{userName}</h2>
                            <h4>{userRole}</h4>
                        </div>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            style={{ width: 50, height: 50, color: "#479BD2" }}
                        >
                            <path
                                fillRule="evenodd"
                                d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </div>
                    <ul className="accountmenu-ul">
                        <li>
                            <Link
                                to={"/my-account"}
                                style={{
                                    display: "flex",
                                    textDecoration: "none",
                                    color: "inherit",
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    style={{
                                        width: 22,
                                        height: 22,
                                        color: "#334D6E",
                                        marginLeft: -2,
                                        marginBottom: -2,
                                        marginRight: -2,
                                    }}
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                                <p>My Account</p>
                            </Link>
                        </li>
                        {!mediaQueryMobile.matches && (
                            <>
                                <li
                                    id="testDashboardTourFlow-selector-11"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        if (steps.length == 0) return;

                                        handleClose();
                                        setCurrentStep(0);
                                        setIsOpen(true);
                                        if (
                                            location.pathname !== "/workflows"
                                        ) {
                                            navigate("/workflows");
                                        }
                                    }}
                                >
                                    <img
                                        src={quickGuideIcon}
                                        alt="quick-guide"
                                    />
                                    <p>Quick guide</p>
                                </li>
                                <a
                                    className="external-link"
                                    href="https://hirequotient.tawk.help"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img
                                        src={knowledgebaseicon}
                                        alt="knowledge-base"
                                    />
                                    <p>Knowledge base</p>
                                </a>
                            </>
                        )}
                        <li
                            style={{ cursor: "pointer" }}
                            onClick={
                                mediaQueryMobile.matches
                                    ? () => setOpenLogoutModal(true)
                                    : onLogout
                            }
                            id="testLogoutFlow-selector-3"
                        >
                            <img src={logouticon} alt="" />
                            <p>Logout</p>
                        </li>
                    </ul>
                    <div className="accountmenu-footer">
                        <p>write to us:</p>
                        <p>
                            <a href="mailto:recruiter-support@hirequotient.com">
                                recruiter-support@hirequotient.com
                            </a>
                        </p>
                    </div>
                </div>
                {mediaQueryMobile.matches && (
                    <div className="logout-modal" ref={logoutModalRef}>
                        <div className="logout-modal__content">
                            <p className="logout-modal__content-heading">
                                Are you sure you want to log out?
                            </p>
                            <button
                                className="logout-modal__content-btn"
                                onClick={onLogout}
                            >
                                Yes
                            </button>
                        </div>
                    </div>
                )}
            </Menu>
        </>
    );
};

const mapStateToProps = createStructuredSelector({
    userName: getUserName(),
    userRole: getUserRole(),
});

const mapDispatchToProps = (dispatch) => ({
    logoutUser: (data) => dispatch(logoutUserRequest(data)),
});

AccountMenu.propTypes = {
    userName: PropTypes.string,
    userRole: PropTypes.string,
    logoutUser: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountMenu);
